import { createFileRoute } from '@tanstack/react-router';
import { DocumentPage, validateNewDocSearch } from '@/components/sales/document-page';

export const Route = createFileRoute('/sales/quotes/new')({
  component: New,
  validateSearch: validateNewDocSearch,
});

function New() {
  const s = Route.useSearch();
  return <DocumentPage kind="quote" {...s} />;
}
